module.exports = __webpack_public_path__ + "media/images/theodor_herzl_award/logo-bg-gold-e267633b90b49face9332c954ac5602a.svg";